export const environment = {
  production: false,
  hmr: true,
  // baseUrl:'http://192.168.20.25:8080', // smile pc
  baseUrl: 'https://api.staging.ikooworld.com',
  enkey: 'vinay@4471#74@0#2.8@kumar',
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};